'use client';

import {useEffect} from 'react';

interface ImportGameThemeProps {
  themeColors?: Record<string, string>;
}

export default function ImportGameTheme({themeColors}: ImportGameThemeProps) {
  useEffect(() => {
    if (!themeColors) {
      return;
    }

    for (const [key, value] of Object.entries(themeColors)) {
      document.documentElement.style.setProperty(`--${key}`, value);
    }
    if (themeColors['mode'] === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [themeColors]);
  return <></>;
}
